<cmi-breadcrumb />
@if (searchTerm()) {
  <cmi-search-results
    [searchTerm]="searchTerm()"
    [tag]="(tag$ | async) ?? null"
    (closeResults)="onCloseResults()" />
} @else {
  @let contentProviders = contentProviders$ | async;
  @for (provider of contentProviders; track provider.key) {
    <a
      [routerLink]="['/apps', tag$ | async, 'providers', provider.key]"
      class="flex items-center justify-between py-4 hover:bg-gray-50 group transition-colors cursor-pointer"
      [title]="provider.key">
      <div class="flex items-center gap-4 flex-1 min-w-0">
        <div class="shrink-0 text-gray-500 items-center inline-flex group-hover:text-main">
          <cmi-provider-type-icon [providerType]="provider.providerType" />
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-base font-medium text-gray-900 truncate group-hover:text-main">
            {{ provider.key }}
          </span>
          <span class="text-sm text-gray-500 truncate">{{ provider.description }}</span>
        </div>
      </div>
      <div class="shrink-0 flex items-center gap-2">
        @if (provider.providerType === 'List' || provider.providerType === 'String') {
          <button
            class="text-main group rounded shrink-0 flex items-center justify-center"
            (click)="addProvider(provider); $event.stopPropagation(); $event.preventDefault()"
            [title]="'contentProviders.add' | translate"
            [attr.aria-label]="'contentProviders.add' | translate"
            type="button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 group-hover:fill-cmi-gray-light">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </button>
        }
        <svg
          class="w-5 h-5 text-gray-400 stroke-current group-hover:text-main"
          fill="none"
          viewBox="0 0 20 20">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </a>
  } @empty {
    <div class="text-center text-gray-500 py-8">
      {{ 'contentProviders.noContentProvidersAvailable' | translate }}
    </div>
  }
}
<ng-template #footerPortal>
  <cmi-search-bar
    class="w-full"
    [searchTerm]="searchTerm()"
    (searchTermChanged)="onSearchTermChanged($event)" />
</ng-template>
